import type { AxiosInstance } from 'axios'
import type { ITrainingMaterialService } from "./training-material.type"
import axios from '@/api/axios'
import type { ITrainingMaterialData } from "@/models/training_material"

export class TrainingMaterialService implements ITrainingMaterialService {
  private endpoint: string

  constructor(private axios: AxiosInstance) {
    this.endpoint = 'v1/training-materials/'
  }

  async fetchTrainingMaterials(): Promise<ITrainingMaterialData[]> {
    return this.axios.get(this.endpoint)
      .then(({ data }) => data)
  }
}

// Default export instantiation of the TrainingMaterialService
const trainingMaterialService = new TrainingMaterialService(axios)
export default trainingMaterialService